<template>
	<v-navigation-drawer 
		v-model="drawer" 
		app 
		clipped  
		color="primary" 
		dark   
		permanent
		width="100px"
		class="d-flex flex-column justify-start"
		height="100%"
	>
		<v-list dense>
			<v-list-item class="px-0">
				<v-img src="@/assets/fps.png" contain width="75" height="75" />
			</v-list-item>
			<v-divider class="my-2" />

			<v-list-item v-if="0" dense class="pa-0 d-flex align-start pt-6 flex-column">
				<v-list-item-avatar class="ma-0 d-flex justify-center">
					<v-img src="../assets/circle-user.svg"  width="80"  class="d-flex justify-center px-6" />
				</v-list-item-avatar>

				<v-list-item-content>
					<span class="text-center"> 
						<span class="text-center font-weight-bold Urbanist-font"> Rasha </span> 
						<br/>
						<span class="text-center Urbanist-font" style="font-size: 10px">Frontend Developer </span>
					</span>
				</v-list-item-content>
			</v-list-item>

			<v-divider v-if="0" />
			<!-- 	@click="item.title === 'To profile' ? profile = !profile : null " -->
			<div 
				v-for="(item, l) in items"
				:key="l"
			>
				<v-list-item
					v-if="item.show"
					link
					:to="$route.name !== item.name ? { name: item.name } : {}"
					class="d-flex flex-column align-end ma-0 mx-4 my-1"
					exact
					exact-path
				>
					<v-list-item-action class="mb-0 mx-0 ">
						<!-- <v-icon>{{ item.icon }}</v-icon> -->
						<!-- <v-img v-if="item.img" src="../assets/Vectors/home.svg" width="20" /> -->
						<img v-if="item.img" :src="item.img" width="25" height="25" alt="tt" />
						<v-icon v-if="item.icon"> {{ item.icon }} </v-icon>
					</v-list-item-action>
					<v-list-item-content class="pb-0 text-center px-3">
						<v-list-item-title>{{item.title.split(' ')[0]}}
							<br/>
							<span class="font-class">
								{{item.title.split(' ')[1]}}
							</span>
							
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</div>
		</v-list>
	</v-navigation-drawer>
</template>

<script>
import { userType } from '@/helper/enum'
import { mapState } from 'vuex'
export default {
	name: 'navigation-drawer',

	props: { 
		// myProfile: { type: Boolean }
		profile: { type: Boolean }
	},

	data: () => ({
		drawer: true,
		userType
	}),

	computed: {
		...mapState({
			type: state => state.auth.self.userType,
			myData: state => state.users.myData
		}),

		items () {
			const items = [
				{
					name: 'HomeView',
					title: 'Home',
					img: require('@/assets/Vectors/home.svg'),
					show: true
				},
				{
					name: 'all-employees',
					title: 'Employees',
					img: require('@/assets/Vectors/employees.svg'),
					show: (this.type === userType.Admin) || (this.type === userType.Administrative && !this.profile)
				},
				{
					name: 'projects',
					title: 'Projects',
					img: require('@/assets/Vectors/projects.svg'),
					show: this.type === userType.Admin || (this.type === userType.Administrative && !this.profile)
				},
				{
					name: 'task-papers',
					title: 'Submitted Tasks',
					img: require('@/assets/Vectors/task-paper.svg'),
					show: this.type === userType.Admin || (this.type === userType.Administrative && !this.profile)
				},
				{
					name: 'employee-project-statistics',
					title: 'Salary',
					icon: 'mdi-sack-percent',
					show: this.type === userType.Admin || (this.type === userType.Administrative && !this.profile)
				},
				// {
				// 	name: 'project-statistics',
				// 	title: 'Project',
				// 	icon: 'mdi-chart-bar',
				// 	show: this.type === userType.Admin
				// },
				// {
				// 	name: 'employee-overview-statistics',
				// 	title: 'Employee Overview',
				// 	icon: 'mdi-code-tags',
				// 	show: this.type === userType.Admin || this.type === userType.Administrative
				// },
				{
					name: 'all-tasks',
					title: 'Tasks',
					img: require('@/assets/Vectors/task-paper.svg'),
					// icon: 'mdi-code-tags',
					show: this.type === userType.Developer || (this.type === userType.Administrative && this.profile) || (this.type === userType.Employee)
				},
				{
					name: 'weekly-plan',
					title: 'Plan',
					// icon: 'mdi-code-tags',
					img: require('@/assets/Vectors/plan.svg'),
					show: true
				},
				{
					name: 'project-statistics',
					title: 'Project statistics',
					icon: 'mdi-state-machine',
					// img: require('@/assets/Vectors/.svg'),
					show: this.type === userType.Admin || (this.type === userType.Administrative && !this.profile)
				},
				{
					name: 'employee-leaves',
					title: 'Leaves',
					img: require('@/assets/Vectors/plan.svg'),
					show: this.type !== userType.Admin
				},
				{
					name: 'leaves-managements',
					title: 'Leaves Managements',
					img: require('@/assets/Vectors/plan.svg'),
					show: this.type === userType.Admin || this.myData.isSupervisor
				}
				// {
				// 	name: 'features-page',
				// 	title: 'Features',
				// 	img: require('@/assets/Vectors/plan.svg'),
				// 	show: true
				// }
			]
			return items
		}
	},

	methods: {
		toggleDrawer () {
			this.drawer = !this.drawer
		}
	}
}
</script>
<style scoped>
/* a.d-flex.flex-column.align-end.ma-0.ma-4.v-list-item--active.v-list-item.v-list-item--dense.v-list-item--link.theme--dark {
	min-height: 20px;
}

a.d-flex.flex-column.align-end.ma-0.ma-4.v-list-item.v-list-item--dense.v-list-item--link.theme--dark {
	min-height: 20px;
} */
a.d-flex.flex-column.align-end.ma-0.mx-4.v-list-item.v-list-item--dense.v-list-item--link.theme--dark {
	min-height: 20px;
}
a.d-flex.flex-column.align-end.ma-0.mx-4.v-list-item--active.v-list-item.v-list-item--link.theme--dark {
		min-height: 20px;
}

.pa-0.d-flex.align-start.pt-6.flex-column.v-list-item.v-list-item--dense.theme--dark {
	min-height: 10px;
}

/* a.d-flex.flex-column.align-end.ma-0.mx-4.v-list-item--active.v-list-item.v-list-item--link.theme--dark {
	min-height: auto !important;
} */
a.d-flex.flex-column.align-end.ma-0.mx-4.v-list-item.v-list-item--link.theme--dark {
	min-height: 17px !important;
}

a.d-flex.flex-column.align-end.ma-0.mx-4.v-list-item--active.v-list-item.v-list-item--link.theme--dark:active{
	border: 1px solid transparent;
	border-radius: 10px
}

/* ::before {
	
} */
.theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::before {
	border: 1px solid transparent;
	border-radius: 10px;
	padding-left: 20px;
	padding-right: 20px;
}
.font-class{
	font-size: 10px;
}
</style>
